import { Fragment, useState, useEffect, useRef } from "react";
import "./ParentHeaderRight.scss";

import images from "../../../utilities/images/images";

import { isEmpty } from "../../../custom_utilities/custom_useful_functions";

//Redux
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { logoutParentUser } from "../../redux/authSlice/AuthSlice";
import { setLoginCandidate } from "../../../redux/login/LoginSlice";
//use state for notification

import Notification from "../notificationicon/notification";

const ParentHeaderRight = (props) => {
  let {
    userData,
    logoutUser,
    studentProfileDetails,
    parentProfileDtails,
    parentNum,
    setLoginCandidate,
  } = props;
  const history = useHistory();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showNotification, setShowNotification] = useState(false);

const fileInputRef = useRef(null);
const [uploadedPhoto, setUploadedPhoto] = useState(images.users_icon);

const openFileDialog = () => {
  fileInputRef.current.click();
};

const handleFileChange = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const imageURL = URL.createObjectURL(file);
  setUploadedPhoto(imageURL);
};

  const handleUserLogout = () => {
    setShowLogoutModal(true); 
  };

  const confirmLogout = () => {
    logoutUser();
    setLoginCandidate("student");
    history.push("/");
    setShowLogoutModal(false);
  };

  const cancelLogout = () => {
    setShowLogoutModal(false);
  };

  //for notification popup
  const bellRef = useRef(null);
  const notificationRef = useRef(null);
  const popup = () => {
    setShowNotification(!showNotification);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target) &&
        bellRef.current &&
        !bellRef.current.contains(event.target)
      ) {
        setShowNotification(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Fragment>
      <div className="headerRight_wrapper">
        <div className="headerRight_inner_wrapper">
          <div className="userName_and_image_wrpr">
            <div className="userName_and_image_inner_wrapper">
              <div className="content_wrapper">
                <div className="dropdown image_container">
                  <button
                    className="btn dropdown-toggle custom_dropdown_toggle"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <span className="image_wrapper">
                      <span className="image_inner_wrapper">
                        {!isEmpty(studentProfileDetails) ? (
                          studentProfileDetails.image.length ? (
                            <img src={studentProfileDetails.image} alt="" />
                          ) : (
                            <img src={images.dummy_user_img} alt="" />
                          )
                        ) : (
                          <img src={images.dummy_user_img} alt="" />
                        )}
                      </span>
                    </span>
                  </button>

                  <div
                    className="dropdown-menu custom_dropdown_menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                                       {/* <div className="profile_option_wrapper">
                      <div className="profile_option_inner_wrapper">
                        <div className="student details_wrapper">
                          <div className="wrapper_heading">
                            <h1>Student Details</h1>
                          </div>

                          <div className="row first-row">
                            <div className="col-sm-6 text-left">Name</div>
                            <div className="col-sm-6 text-right">
                              {studentProfileDetails.name}
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-6 text-left">Roll No.</div>
                            <div className="col-sm-6 text-right">
                              {" "}
                              {studentProfileDetails.roll_no}
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-sm-6 text-left">Mbl. No.</div>
                            <div className="col-sm-6 text-right">
                              {studentProfileDetails.mobile}
                            </div>
                          </div>
                        </div>

                        <div className="details_wrapper">
                          <div className="wrapper_heading">
                            <h1>Parent Details</h1>
                          </div>

                          <div className="row first-row">
                            <div className="col-sm-6 text-left">Name</div>
                            <div className="col-sm-6 text-right">
                              {parentProfileDtails.f_name}
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-sm-6 text-left">Mbl. No.</div>
                            <div className="col-sm-6 text-right">
                              {parentNum}
                            </div>
                          </div>
                        </div>

                        <div className="details_wrapper">
                          <div className="wrapper_heading">
                            <h1>Course Details</h1>
                          </div>

                          <div className="row first-row">
                            <div className="col-sm-6 text-left">Course</div>
                            <div className="col-sm-6 text-right">
                              {studentProfileDetails.course}
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-6 text-left">Class</div>
                            <div className="col-sm-6 text-right">
                              {" "}
                              {studentProfileDetails.classes}
                            </div>
                          </div>

                          <div className="row last-child">
                            <div className="col-sm-6 text-left">
                              Study Centre
                            </div>
                            <div className="col-sm-6 text-right">
                              {" "}
                              {studentProfileDetails.center}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}
                 <div className="profile-details">
 <h3 className="student-head">Profile details (Student)</h3>
  <div className="student-header">
    <div className="photo-wrapper">
      {/* <img
        src={images.users_icon}
        alt="student"
        className="student-photo"
      />
      <img
        src={images.edit_icon}
        alt="edit"
        className="edit-icon"
      /> */}
      <img
  src={uploadedPhoto}
  alt="student"
  className="student-photo"
/>

<img
  src={images.edit_icon}
  alt="edit"
  className="edit-icon"
  onClick={openFileDialog}
  style={{ cursor: "pointer" }}
/>

<input
  type="file"
  accept="image/*"
  ref={fileInputRef}
  style={{ display: "none" }}
  onChange={handleFileChange}
/>

    </div>

    <div>
      <p className="student-name">{studentProfileDetails.name}</p>
      <p className="student-number">{studentProfileDetails.roll_no}</p>
    </div>
  </div>
    <div className="info-box">
  <p>Target: <span>{studentProfileDetails.target}</span></p>
  <p>Center: <span>{studentProfileDetails.center}</span></p>
  <p>Mbl. No.: <span>{studentProfileDetails.mobile}</span></p>
  <p>Class: <span>{studentProfileDetails.classes}</span></p>
  <p>Course: <span>{studentProfileDetails.course}</span></p>
  <p>Batch: <span>{studentProfileDetails.batch}</span></p>
</div>

  <div className="parent-head">Parent Details</div>

  <div className="info-box">
    <p>Name: <span>{parentProfileDtails.f_name}</span></p>
    <p>Mbl. No.: <span>{parentNum}</span></p>
  </div>
               </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="notification_container">
            {/* Bell Icon */}
            <div className="notification_wrapper" onClick={popup} ref={bellRef}>
              <div className="noti_image_wrapper">
                <img src={images.notificationbell} alt="notification" />
              </div>
            </div>

            {/* Notification box with ref */}
            {showNotification && (
              <div ref={notificationRef}>
                <Notification />
              </div>
            )}
          </div>

          {showLogoutModal && (
            <div className="custom_modal_overlay">
              <div className="custom_modal_content">
                <p>Are you sure you want to logout?</p>
                <div className="modal_buttons">
                  <button className="yes_btn" onClick={confirmLogout}>
                    Yes
                  </button>
                  <button className="no_btn" onClick={cancelLogout}>
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}
          <div className="logout_wrapper">
            <div className="image_wrapper" onClick={handleUserLogout}>
              <img src={images.parent_logout} alt="Logout" />
            </div>
          </div>
          
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    studentProfileDetails:
      state.parentrootReducer.parentAuthReducer.studentProfileDetails,
    parentProfileDtails: state.parentrootReducer.parentAuthReducer.user,
    parentNum: state.parentrootReducer.parentAuthReducer.mobile_number,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    logoutUser: (payload) => {
      dispatch(logoutParentUser(payload));
    },

    setLoginCandidate: (payload) => {
      dispatch(setLoginCandidate(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ParentHeaderRight);
